var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
        'violation-toggler__delete-task': true,
        'violation-toggler__delete-task_open': _vm.isDelete,
    },on:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.$t('components.violationTask.askDelete'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }